import React from "react";
import Header from "../navigation/header";
import Home from "./home";
import Footer from "../navigation/footer";

export default function HomePage(){

    return(
        <>
        <Header />
        <Home />
        <Footer />
        </>

    )
}